import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { DossierModel } from '@app/authority/authority-shared/models/dossier.model';
import { NoteReferenceType } from '@app/authority/authority-shared/models/enums.model';
import { FluxAuthorityService } from '@app/authority/authority-shared/services/flux/flux.authority.service';
import { EAction } from '@app/authority/authority-shared/services/flux/flux.actions.model';
import { UserPermissionsModel } from '@app/shared/models/user-permission.model';
import { PermissionService } from '@app/shared/service/permission.service';
import { logger } from '@app/shared/utilities/logger.model';
import { WorkingModel } from '@authority/authority-shared/models/working.model';
import {GeneralNoteModel} from '@shared/models/general-note.model';
import {TranslateContext} from '@shared/pipes/translate.pipe';
import {UserV3Service} from '@shared/service/user-v-3.service';
import { Utilities } from '@shared/utilities/utilities.model';

export const generalNoteQuillConfig: any = {
	toolbar: [
		['bold', 'italic', 'underline'],
		[{'list': 'ordered'}, {'list': 'bullet'}],
	]
};

@Component({
	selector: 'amd-general-note-dialog',
	templateUrl: './general-note-dialog.component.html',
	styleUrls: ['./general-note-dialog.component.scss']
})
export class GeneralNoteDialogComponent implements OnInit {

	note: GeneralNoteModel;
	noteForm: FormGroup;
	workingsList: WorkingModel[];
	isALD: boolean = null;
	canDeleteAttachmentStatus: string[] = [];
	haveNoteType: boolean = true;//Mostra di default la sezione inerente alla select basata su configMap per la scelta del tipo di nota
	private userPermission: UserPermissionsModel;
	private dossier: DossierModel;

	get quillConfig(): any {
		return generalNoteQuillConfig;
	}

	get noteTypes(): string[] {

		try {
			const list = Array.from(this.data.configMap.keys());
	
			// se l'intervento è stato creato da LeasePlan Mobility (ovvero ha stop_and_go_id valorizzato),
			// i centri non hanno la gestione sull'intervento
			if (this.dossier && this.dossier.isMobility()) {
				return list.filter(x => x !== NoteReferenceType.AUTHORITY_DOSSIER);
			}
			
			return list;

		} catch (e) {
			logger.error(e);
		}

		return [];
	}

	get referenceList(): any[] {
		return Array.from(this.data.configMap.keys());
	}

	constructor(
		private fb: FormBuilder,
		@Inject(MAT_DIALOG_DATA) public data: GeneralNoteDialogDataInput,
		public dialogRef: MatDialogRef<GeneralNoteDialogComponent>,
		private userService: UserV3Service,
		private permissionService: PermissionService,
		private fluxService: FluxAuthorityService,
	) {
		this.note = data.note;
		this.haveNoteType = !Utilities.isEmpty(data.type_placeholder);
		this.userPermission = this.permissionService.getCurrentUserPermissions();
		this.getDossierFromFlux();
	}

	ngOnInit(): void {
		this.initForm();
		
		this.isALD = this.data.isALD;
		this.canDeleteAttachmentStatus = this.data.canDeleteAttachmentStatus;
		this.workingsList = this.data.workingsList;

		if (this.data.configMap && this.noteTypes.length === 1) {
			this.noteForm.get('reference_type').setValue(this.noteTypes[0]);
			this.onTypeChange(this.noteTypes[0]);
		}

		if(!this.data.isALD && this.data.workingsList){
			this.data.workingsList.forEach(work => {
				if(!this.canDeleteAttachmentStatus.includes(work.status)){
					// era meglio raggruppare in un array unico
					this.data.configMap.get("AUTHORITY_WORKING").reference_list = this.data.configMap.get("AUTHORITY_WORKING").reference_list.filter(item => item.id != work.id);
					this.data.configMap.get("AUTHORITY_ENTRY_PART").reference_list = this.data.configMap.get("AUTHORITY_ENTRY_PART").reference_list.filter(item => item.workingId != work.id);
				}
			});
		}

		// per mobility filtrare solo la singola pratica, o le parti relative, in questione
		if (this.dossier && this.dossier.isMobility()) {

			// in teoria, per mobility la pratica dovrebbe essere solo una
			const working_id_list = this.workingsList.map(x => x.id);
			
			Object.keys(NoteReferenceType).forEach(x => {

				const item = this.data.configMap.get(x);
				
				if (!item) {
					return;
				}

				// se esistono elementi associati al NoteReferenceType
				// in questo caso su AUTHORITY_WORKING, AUTHORITY_ENTRY_PART
				// filtrare solo quelli associati alla pratica in questione
				item.reference_list = item.reference_list.filter(y => working_id_list.includes(y.workingId || y.id));
			});
		}		
	}

	private initForm(): void {
		//Se haveNoteType è falso non sono presenti a FE le select che valorizzano quei campi, quindi diventano opzionali
		this.noteForm = this.fb.group({
			note_text: [undefined, Validators.required],
			reference_type: [undefined, this.haveNoteType ? Validators.required : null],
			reference_id: [undefined, this.haveNoteType ? Validators.required : null]
		});
	}

	changeDescription(note: string): void {
		this.noteForm.get('note_text').patchValue(note);
	}

	saveNote(): void {
		this.dialogRef.close({
			note: {
				user_label: this.userService.getCurrentUser().username,
				reference_id: this.noteForm.get('reference_id').value,
				reference_type: this.noteForm.get('reference_type').value,
				note_text: this.noteForm.get('note_text').value
			}
		});
	}

	onTypeChange(type: any): void {
		this.noteForm.get('reference_id').setValue(null);
		if (!this.data.configMap.get(type).need_sub_reference && this.data.configMap.get(type).reference_list.length>0) {
			this.noteForm.get('reference_id').setValue(this.data.configMap.get(type).reference_list[0].id);
		}
		/*this.entruster = undefined;
		this.entrustedSearchInputCtrl.setValue('');*/
	}
	
	private getDossierFromFlux(): void {
		// flux 
		// this.dossier = this.fluxService.getDossier();
		this.fluxService.setReducer(EAction.GET_DOSSIER, function(res) {
			this.dossier = res;
		}.bind(this));
	}
}

export interface GeneralNoteDialogDataInput {
	workingsList?: WorkingModel[];
	isALD?:boolean;
	canDeleteAttachmentStatus?: string[];
	note: GeneralNoteModel;
	dialog_title: string;
	note_placeholder: string;
	translate_context: TranslateContext;
	type_placeholder: string;
	reference_placeholder: string;
	configMap: Map<any, { need_sub_reference: boolean, reference_list: { id: string, description: string, workingId?: string }[] }>;
	dossier?: DossierModel;
}
